<template lang="pug">
.report
    div.title-wrapper
        PageTitle(
            pagetitle="优化建议操作列表",
            tip="我们将每日为您采纳的建议创建一个优化模板，您可以将优化模板一键同步至点睛生效，同步前您也可以在模板上调整优化内容",
            :showTime="false"
        )
        div.indices-menu.pull-right(v-show="dianjingIDList.length > 0")
            span.font-grey 账号切换：
            v-select(
                v-model="dianjingID",
                :options="dianjingIDList"
            )

    .zone.opt-zone.mt-5
        table.opt-table(:id="'opt-service-table'")
            thead
                tr
                    th(v-for="column in totalColumns.listColumns") {{column}}
            tbody
                template(v-for="(item, index) in tableList")
                    tr(
                        v-show="!isListLoading && tableList.length"
                    )
                        td {{item.template_name}}
                        td {{item.createtime}}
                        td(v-if="item.effecttime.slice(0,4)!=='0000'") {{item.effecttime}}
                        td(v-else) ----
                        
                        td(v-if="item.status === 0") 
                            i.i-ellipsis
                            span.status-txt.status0 {{'待应用'}}
                        td(v-if="item.status === 1") 
                            i.i-check-square
                            span.status-txt.status1 {{'已应用 '}}
                                small {{'（全部生效）'}}
                        td(v-if="item.status === 2") 
                            i.i-check-square
                            span.status-txt.status1 {{'已应用 '}}
                                small {{'（部分生效）'}}
                        td(v-if="item.status === 3") 
                            i.i-minus-circle
                            span.status-txt.status2 {{'已过期'}}
                        td(v-if="item.status === 4") 
                            i.i-download
                            span.status-txt.status2 {{'已下载'}}

                        td.operate-cell
                            i.mr-20.pointer(
                                v-if="item.status === 0",
                                title="编辑", @click.prevent="viewOpt($event, item, true)"
                            ) 编辑
                            i.mr-20.pointer(
                                v-if="item.createtime.slice(0,10) === today && item.status === 2",
                                title="编辑", @click.prevent="viewOpt($event, item, true)"
                            ) 编辑
                            i.mr-20.pointer(
                                v-if="item.createtime.slice(0,10) !== today && item.status === 2",
                                title="查看", @click.prevent="viewOpt($event, item, false)"
                            ) 查看
                            i.mr-20.pointer(
                                v-if="item.status === 1 || item.status === 3 || item.status === 4",
                                title="查看", @click.prevent="viewOpt($event, item, false)"
                            )  查看

                            i.mr-20.pointer(
                                title="删除", 
                                @click="deleteItem($event, item)"
                            ) 删除

                            i.mr-20.pointer(
                                v-if="item.status === 1 || item.status === 2",
                                @click="showEffect($event, item)"
                            ) 效果对比
                            i.mr-20.pointer(v-else) ----

                tr(v-show="!isListLoading && tableList.length === 0")
                  td(colspan="9", style="text-align: center;") 您还未创建任何操作模板，请先返回
                    i.link-opt
                      router-link(:to="'/web/optimizeaccount'") 账户优化
                    | 采纳优化建议
                tr(v-show="isListLoading")
                    td(colspan="9", style="text-align: center;")
                        img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")

        v-pagination(
            :total="total",
            :pn="pageNum",
            :ps="ps",
            @updatepage="getOperateList"
        )
    
    v-modal(
        :id="'opt-modal'",
        :visible="modalSettingVisible",
        :title="modalTitle",
        :sub-title="modalSubTitle",
        :safe="modalSafe",
        @closemodal="modalInfoReset"
    )
        .modal-bd-wrapper.opt-zone(v-if="modalFormat==='linechart'")
            .floatr
                v-radio-group(
                    v-model="indiceSelected",
                    name="indice",
                    :options="indiceList"
                )
            pred-line-chart(
                :legend="legend",
                :xAxis="chartXAxis",
                :series="chartSeries",
                :predseries="predChartSeries",
                :lineXAxis="lineXAxis",
                :areaXAxis="areaXAxis"
            )        
            p.chart-tip(v-show="lineChartTip") {{lineChartTip}}

        .modal-bd-wrapper(v-if="modalFormat==='table'")
            div.min-height-table
                div.modal-shadow
                ul.tab
                    li.tab-item(v-for="item in tabList")
                        .tabview-btn(
                            @click.prevent="changeViewTo(item.id)",
                            :class="{ active: currentTab === item.id}"
                        ) {{item.name}}

                div.modal-table-wrapper
                    KrAdviceTable(
                        v-if="currentTab==='kr'",
                        :hasCheckbox="false",
                        :isEditable="curEditable",
                        :list="krTableList",
                        :extendColumns="extColumn"
                    )
                        template(slot="reasontype")
                        template(slot="delete" scope="props")
                            i.fa.fa-trash(@click.prevent="deleteDetailItem($event, props.item)" v-show="curEditable && props.item.status===0")

                        template(slot="reasontype")
                        template(slot="status" scope="props")
                            span(v-show="!curEditable && props.item.status===0") 已过期

                    ServiceAdviceTable(
                        v-if="currentTab==='service'",
                        :id="'op-service-table'",
                        :hasCheckbox="false",
                        :isEditable="curEditable",
                        :list="serviceTableList",
                        :extendColumns="extColumn"
                    )
                        template(slot="reasontype")
                        template(slot="delete" scope="props")
                            i.fa.fa-trash(@click.prevent="deleteDetailItem($event, props.item)" v-show="curEditable && props.item.status===0")

                        template(slot="reasontype")
                        template(slot="status" scope="props")
                            span(v-show="!curEditable && props.item.status===0") 已过期

                    BudgetAdviceTable(
                        v-if="currentTab==='accountBudget'",
                        :hasCheckbox="false",
                        :isEditable="curEditable",
                        :bgtype = "currentTab==='accountBudget' ? 'custname' : 'plan'",
                        :list="accountBudgetTableList",
                        :extendColumns="extColumn"
                    )
                        template(slot="reasontype")
                        template(slot="delete" scope="props")
                            i.fa.fa-trash(@click.prevent="deleteDetailItem($event, props.item)" v-show="curEditable && props.item.status===0")

                        template(slot="reasontype")
                        template(slot="status" scope="props")
                            span(v-show="!curEditable && props.item.status===0") 已过期
                            
                    BudgetAdviceTable(
                        v-if="currentTab==='planBudget'",
                        :hasCheckbox="false",
                        :isEditable="curEditable",
                        :bgtype = "currentTab==='accountBudget' ? 'custname' : 'plan'",
                        :list="planBudgetTableList",
                        :extendColumns="extColumn"
                    )
                        template(slot="reasontype")
                        template(slot="delete" scope="props")
                            i.fa.fa-trash(@click.prevent="deleteDetailItem($event, props.item)" v-show="curEditable && props.item.status===0")

                        template(slot="reasontype")
                        template(slot="status" scope="props")
                            span(v-show="!curEditable && props.item.status===0") 已过期

                    PriceAdviceTable(
                        v-if="currentTab==='price'",
                        :hasCheckbox="false",
                        :isEditable="curEditable",
                        :list="priceTableList",
                        :extendColumns="extColumn"
                    )
                        template(slot="reasontype")
                        template(slot="delete" scope="props")
                            i.fa.fa-trash(@click.prevent="deleteDetailItem($event, props.item)" v-show="curEditable && props.item.status===0")

                        template(slot="reasontype")
                        template(slot="status" scope="props")
                            span(v-show="!curEditable && props.item.status===0") 已过期

                    PauseAdviceTable(
                        v-if="currentTab==='krPause'",
                        :hasCheckbox="false",
                        :isEditable="curEditable",
                        :list="krPauseTableList",
                        :extendColumns="extColumn"
                    )
                        template(slot="reasontype")
                        template(slot="delete" scope="props")
                            i.fa.fa-trash(@click.prevent="deleteDetailItem($event, props.item)" v-show="curEditable && props.item.status===0")

                        template(slot="reasontype")
                        template(slot="status" scope="props")
                            span(v-show="!curEditable && props.item.status===0") 已过期
                            
                p.note-text(v-show="(currentTemplateStatus===0 || currentTemplateStatus===4 ) && isSpecialUser===true && currentTemplateToday === true") 说明：下载模板可上传至点睛，只可下载关键词拓展、关键词优化模块，其他模块请手动操作      

                p.btn-wrapper.btn-absolute(v-show="(currentTemplateStatus===0 || currentTemplateStatus===2) && isSpecialUser===false")
                    button.btn.btn-default(
                        :disabled="!canCurrentTemplateSync",
                        @click.prevent="syncToDianjing($event)"
                    ) 一键同步至点睛
                    button.btn.btn-primary(
                        @click.prevent="saveTemplate($event)"
                    ) 保存
                p.btn-wrapper.btn-absolute(v-show="(currentTemplateStatus===0 || currentTemplateStatus===4 ) && isSpecialUser===true && currentTemplateToday === true")
                    DownloadBtn(
                        v-if="currentTemplateStatus===0",
                        :reportApi="downloadApi",
                        :params="downloadParams",
                        pagetitle="优化建议操作列表",
                        btnTitle="下载模板"
                    )
                    DownloadBtn(
                        v-if="currentTemplateStatus===4",
                        :reportApi="downloadApi",
                        :params="downloadParams",
                        pagetitle="优化建议操作列表",
                        btnTitle="再次下载"
                    )
                    button.btn.btn-primary(
                        v-if="currentTemplateStatus===0",
                        @click.prevent="saveTemplate($event)"
                    ) 保存

                div.sync-alert-wrapper
                    i.fa.fa-times.close(@click.prevent="closeSyncAlert()")
                    div.diff-wrapper(v-if="alertStatus===1")
                        p.title
                            i.fa.fa-ellipsis-h
                            span 正在同步至点睛用户
                        p.alert-content 请耐心等待...
                    
                    div.diff-wrapper(v-if="alertStatus === 2")
                        p.title
                            i.fa.fa-check-circle
                            span 同步完成
                        p.alert-content {{alertContentTotal}}
                        p.btn-wrapper
                            button.btn.btn-primary(
                                @click.prevent="closeSyncAlert()"
                            ) 确定

                    div.diff-wrapper(v-if="alertStatus === 3")
                        p.title
                            i.fa.fa-info-circle
                            span 同步未全部完成
                        p.alert-content.alert-top {{alertContentParticial}}
                        p.alert-content 若继续同步失败，建议您稍候重试或联系客服人员 
                        p.btn-wrapper
                            button.btn.btn-primary(
                                @click.prevent="syncToDianjing($event)") 继续同步
                            button.btn.btn-default(
                                @click.prevent="closeSyncAlert()"
                            ) 取消
                    i.alert-wrapper-arrow

</template>



<script>
import Vue from 'vue';
import Mixin from '../mixin.js'
import { getDateString, getQueryString, datePlus } from '../../script/util';
import KrAdviceTable from './kr_advice_table.vue'
import ServiceAdviceTable from './service_advice_table.vue'
import BudgetAdviceTable from './budget_advice_table.vue'
import PriceAdviceTable from './price_advice_table.vue'
import PauseAdviceTable from './pause_advice_table.vue'
import PredLineChart from '../../component/charts/predictlinechart.vue'
import Store from '../../store/store.js'

export default {
    store: Store,
    mixins: [Mixin],
    components : {
        KrAdviceTable,
        ServiceAdviceTable,
        PriceAdviceTable,
        PauseAdviceTable,
        BudgetAdviceTable,
        'pred-line-chart': PredLineChart
    },

    data() {
        let today = getDateString.today();
        return { 
            commonLabel : '数据解读',
            isListLoading : false,

            today : today,
            pageNum : 1,
            total : 0,
            ps : 10,
            
            dianjingID: '',
            dianjingIDList: [],

            tableList : [],
            krTableList : [],
            serviceTableList : [],
            accountBudgetTableList : [],
            planBudgetTableList : [],
            priceTableList : [],
            krPauseTableList : [],

            isSpecialUser : false,

            islineChartDataValid : true,
            lineChartTip : '数据解读：效果对比区域展示了该优化模板的预估与真实数据对比，其中预估数据为结合您采纳的意见及相应修改计算出的数据。',
            chartData: {},
            legend: [],
            chartXAxis: [],
            chartSeries: [],
            predChartSeries: [],
            lineXAxis: [],
            areaXAxis: [],
            indiceSelected: 'adpv',
            indiceList: [{
                title: "展现量",
                value: "adpv"
            },{
                title: "点击量",
                value: "adclick"
            }],
            
            currentTab : 'kr',
            currentColumns : ["推荐关键词", "推广组", "推广计划", "匹配模式", "出价建议（￥）", "操作"],
            curEditable : false,

            currentTemplateID : 0,
            currentTemplateStatus : 0,
            currentTemplateToday : false,
            canCurrentTemplateSync : true,

            modalSettingVisible : false,
            modalTitle : '',
            modalSubTitle : '',
            modalSafe : true,
            modalFormat : '',
            
            tableDetailsList : [],
            tabList : [{
                id : 'kr', 
                name : '关键词拓展' 
            },{
                id : 'price', 
                name : '关键词优化' 
            },{
                id : 'service', 
                name : '投放时间优化' 
            },{
                id : 'accountBudget', 
                name : '整体预算' 
            },{
                id : 'planBudget', 
                name : '计划预算' 
            },{
                id : 'krPause',
                name : '暂停关键词'
            }],
            totalColumns : {
                listColumns : ["优化模板名称", "创建时间", "生效时间", "模板状态", "操作"],
                krColumns : ["推荐关键词", "推广组", "推广计划", "匹配模式", "出价建议（￥）", "操作"],
                priceColumns : ["优化关键词", "推广组", "推广计划", "匹配模式", "建议匹配模式", "当前出价", "出价建议（￥）", "操作"],
                serviceColumns : ["推广计划", "当前投放时间", "推荐投放时间", "操作"],
                accountBudgetColumns : ["推广计划", "过去7天撞线", "预估损失展现","当前预算","建议预算", "操作"],
                planBudgetColumns : ["推广计划", "过去7天撞线", "预估损失展现","当前预算","建议预算", "操作"],
                krPauseColumns : ["优化关键词", "展现量", "点击量", "推广组", "推广计划", "匹配模式", "当前出价", "出价建议（￥）", "操作"]
            },

            alertStatus : 1,
            suggestTotalNum : 0,
            suggestSuccessNum : 0,

        };
    },

    computed : {
        hasEditItem() {
            let hasEdit = false;
            _.map(this.$store.state.tableCheckList, (item) => {
                for(let key in item) {
                    if(/^priceEdit$/.test(key) && item[key]) {
                        hasEdit = true;
                        return; 
                    }
                }
            })
            return hasEdit;
        },
        extColumn() {
            let delExtend = [{ 
                title : '操作',
                key : 'delete',
                class : 'center',
                render : this.emptyRender
            }];
            let statExtend = [{ 
                title : '状态',
                key : 'status',
                class : 'center',
                render : this.emptyRender
            }];
            if (this.curEditable) {
                return delExtend;
            } else {
                if (this.currentTemplateStatus === 2) {
                    return statExtend;
                }
                return [];
            }  
        },
        domainId() {
            return this.$store.state.domainId;
        },
        downloadApi() {
            return "/api/aoTmpl/downloadTmpl";
        },
        downloadParams() {
            return _.extend({}, this.params, { template_id : this.currentTemplateID, filetype : 'zip'} );
        },
        alertContentTotal() {
            return `共${this.suggestTotalNum}条建议，已全部同步成功！`;
        },
        alertContentParticial() {
            return `共${this.suggestTotalNum}条建议，仅同步成功 ${this.suggestSuccessNum} 条！`;
        },
        params() {
            return {
                domainId : this.domainId,
                djid : this.dianjingID
            }
        }
    },

    created() {
        this.getSiteDianjingIDsWithoutWhole();
    },

    watch : {
        domainId() {
            this.dianjingID = ''
            this.getSiteDianjingIDsWithoutWhole();
        },
        indiceSelected() {
            this.getLineChartData();
        },
        dianjingID(newVal, oldVal) {
            this.$store.commit("SET_DIANJINGID", this.dianjingID)
            this.getOperateList();
        }
    },
    
    methods : {
        emptyRender() {
            return '';
        },
        setDefaultDianjingID() {
            if (_.find(this.dianjingIDList, {value : +getQueryString('dj')})) {
                this.dianjingID = +getQueryString('dj');
            } else {
                this.dianjingID = this.dianjingIDList[0].value;
            }
            this.$store.commit("SET_DIANJINGID", this.dianjingID);
        },
        //获取趋势图数据
        getChartData(item) {
            let params = _.extend({}, this.params, { template_id : item.id });
            let lineChartPromise = this.$http.get('/api/aoTmpl/report', {params: params});
            this.$store.dispatch('VUE_HTTP', [lineChartPromise])
                .then( (res) => {
                    let errno = res.errno;
                    if (errno === 0) {
                        let curTime = item.createtime.slice(0,10);
                        this.chartData = res;
                        
                        this.$store.state.start = datePlus(curTime, -7);
                        this.$store.state.end = datePlus(curTime, 7);
                        this.getLineChartData();
                        this.modalSettingVisible = true; 
                    } else if (errno > 0) {
                        this.$Modal.warn(res.errMsg);
                    }
                });
        },
        //趋势图所需数据
        getLineChartData() {
            if (_.isEmpty(this.chartData)) return 
            let chartData = _.cloneDeep(this.chartData)
            chartData.selectedIndice = this.indiceSelected;
            if (_.isEmpty(chartData.trend) || _.isEmpty(chartData.history)) {
                this.chartSeries = [];
                this.islineChartDataValid = false;
            } else {
                this.islineChartDataValid = true;
                let [legend, xAxis, series, predSeries, lineXAxis, areaXAxis] = this.processPredictData(chartData)
                
                this.legend = legend;
                this.chartXAxis = xAxis;
                this.chartSeries = series;
                this.predChartSeries = predSeries;
                this.lineXAxis = lineXAxis;
                this.areaXAxis = areaXAxis;
            }
        },

        getOperateList( pn = 1 ) {
            if (!this.domainId) {
                return;
            }

            this.isListLoading = true;
            this.pageNum = pn;
            this.tableList = [];
            
            let params = _.extend({}, this.params, { pg : this.pageNum, ps : this.ps });
            let optListPromise = this.$http.get(`/api/aoTmpl/list`, { params : params });
            this.$store.dispatch("VUE_HTTP", [optListPromise])
                .then( (res) => {
                    this.isListLoading = false;
                    if (res.errno > 0) {
                        this.$Modal.warn(res.errMsg);
                        return;
                    }
                    this.tableList = res.list || [];
                    this.total = res.total || 0;
                });
         },

         //get modal detail list, and open modal
         viewOpt(evt, item={}, editable=false) {
             evt.stopPropagation();
             
             if (item.createtime.slice(0,10) === this.today) {
                 this.currentTemplateToday = true;
             }
             this.currentTemplateID = item.id;
             this.currentTemplateStatus = item.status;
             this.modalFormat = 'table';
             this.curEditable = editable;
             this.modalTitle = '账户优化模板-' + item.template_name;

             let params = _.extend({}, this.params, { source_key : window.$sourceKey, template_id : item.id });
             let syncPermission = this.$http.get("/api/aoTmpl/syncPermission", {params : params});
             this.$store.dispatch("VUE_HTTP", [syncPermission])
                 .then( (res) => {
                     if (res.errno > 0) {
                         this.isSpecialUser = true;
                     }

                     this.getDetailList('kr');

                     setTimeout(() => {
                         this.modalSettingVisible = true;
                     }, 300);
                 });
         },

         saveTemplate() {
             if(this.hasEditItem) return this.$Modal.warn("请保存编辑项")
             let checkList = this.$store.state.tableCheckList;
             if (_.isEmpty(checkList)) {
                 this.$Modal.warn("保存成功");
                 return;
             } 
             let jsonData = JSON.stringify(checkList);
             let params = _.extend({
                 module : this.currentTab, 
                 data : jsonData 
             }, this.params);
             let saveEditPromise = this.$http.post("/api/aoTmpl/edit", params, {emulateJSON: true});
             this.$store.dispatch("VUE_HTTP", [saveEditPromise])
                 .then( (res) => {
                     if (res.errMsg) {
                         this.$Modal.warn(res.errMsg);
                     } else {
                         this.$Modal.warn("保存成功");
                     }       
                 });
         },


         modalInfoReset() {
             ['kr', 'service', 'price', 'accountBudget', 'planBudget', 'krPause'].forEach( (type) => {
                 this[type+'TableList'] = [];
             });
             this.$refs.menuform && this.$refs.menuform.resetValidity();
             this.modalSettingVisible = false; 
             this.$store.state.tableCheckList.length = 0;
             this.currentTab = 'kr';
             this.modalFormat = '';
             this.modalTitle = '';
             this.modalSubTitle = '';
             this.indiceSelected = 'adpv';
             this.islineChartDataValid = true;
             this.canCurrentTemplateSync = true;
             this.currentTemplateToday = false;
             if(this.curEditable && this.modalFormat !== 'linechart') {
                 this.getOperateList(this.pageNum);
             }
         },

         showEffect(evt, item) {
             evt.stopPropagation();
             this.modalFormat = 'linechart';
             this.modalTitle = item.template_name + '效果图对比';
             this.getChartData(item);
         },

         deleteItem(evt, item) {
             evt.stopPropagation();
             this.$Modal.confirm('确定删除？', (confirm) => {
                 if (!confirm) return;
                
                 const params = {
                     domainId : this.domainId,
                     djid : this.dianjingID,
                     template_id : item.id
                 };
                 let deletePromise = this.$http.get('/api/aoTmpl/del', { params : params});
                 this.$store.dispatch("VUE_HTTP", [deletePromise])
                     .then( (res) => {
                         this.$Modal.warn('删除成功');
                         this.getOperateList(this.pageNum);
                     }).catch(e => {
                         this.$Modal.warn('删除失败');
                     });
             });        
         },

         deleteDetailItem(evt, item) {
             evt.stopPropagation();
             this.$Modal.confirm('确定删除？', (confirm) => {
                 if (!confirm) return;
                
                 let params = _.extend({}, this.params, { id : item.id, template_id : this.currentTemplateID});
                 let deleteDetailPromise = this.$http.get('/api/aoTmpl/delDetail', { params : params});
                 this.$store.dispatch("VUE_HTTP", [deleteDetailPromise])
                     .then( (res) => {
                         if (res.errno > 0) {
                             this.$Modal.warn(res.errMsg);
                         } else {
                             this.$Modal.warn('删除成功');
                             this.getDetailList(this.currentTab);
                         }
                     }).catch(e => {
                         this.$Modal.warn('删除失败');
                     });
             });        
         },

         //change tab in modal
         changeViewTo(tab) {
             if(this.currentTab == tab) return;
             this.$store.dispatch("SET_TABLE_CHECKLIST", [])
             this.currentTab = tab;
             this.currentColumns = this.totalColumns[this.currentTab+'Columns'];
             this.getDetailList(tab);
         },

         getDetailList(tab) {
             let params = _.extend({}, this.params, { module : tab, template_id : this.currentTemplateID });
             let detailPromise = this.$http.get("/api/aoTmpl/detail", {params : params});
             this.$store.dispatch("VUE_HTTP", [detailPromise])
                 .then( (res) => {
                     if (res) {
                         switch (this.currentTemplateStatus) {
                             case 0:
                                 this.modalSubTitle = this.isSpecialUser ? '（未下载可编辑）' : '（未同步可编辑）';
                                 this.canCurrentTemplateSync = (res.ext_info && res.ext_info.total > 0) ? true : false;
                                 break;
                             case 1:  
                                 this.modalSubTitle = '（已全部生效）';
                                 break;
                             case 2:
                                 if (res.ext_info){
                                     let extInfo = res.ext_info;
                                     this.modalSubTitle = '（共<span style="color:red">' + extInfo.total + '</span>条优化建议，生效<span style="color:red">' + extInfo.success_num + '</span>条）';
                                     this.canCurrentTemplateSync = extInfo.total > 0 ? true : false;
                                 }
                                 break;
                             case 3: 
                                 this.modalSubTitle = '（未应用）'
                                 break;
                             
                             case 4:
                                 this.modalSubTitle = '（已下载）'

                             default : break;
                         }
                         this[tab + 'TableList'] = res.list;      
                     }
                 });
         
         },

         closeSyncAlert() {
             this.alertStatus = 1; 
             document.querySelector(".sync-alert-wrapper").classList.remove("alert-show");
             document.querySelector(".modal-shadow").style.display = "none";
         },

         showSyncAlert() {
             document.querySelector(".sync-alert-wrapper").classList.add("alert-show");
             document.querySelector(".modal-shadow").style.display = "block";
         },
         syncToDianjing(evt) {
             evt.stopPropagation();
             this.alertStatus = 1; 
             let params = _.extend({}, this.params, { source_key : window.$sourceKey, template_id : this.currentTemplateID });
             let syncPromise = this.$http.get('/api/aoTmpl/sync', { params : params});
             this.$store.dispatch("VUE_HTTP", [syncPromise])
                 .then( (res) => {
                     let errno = res.errno;
                     this.showSyncAlert();
                     let self = this;
                     setTimeout(() => {
                         if (errno !== 0){
                             self.closeSyncAlert()
                             self.$Modal.warn(res.errMsg);
                         } else {
                             self.closeSyncAlert()
                             if (errno === 0) {//同步成功，可能全成功，可能部分成功，也可能全没成功（只能说他点儿背）
                                 let total = res.total;
                                 let active_num = res.active_num;

                                 if (active_num === total) { //点儿正，都成功了
                                     self.alertStatus = 2;
                                     self.suggestTotalNum = total || 0;
                                     self.modalSubTitle = '（已全部生效）';
                                     self.showSyncAlert();
                                     self.canCurrentTemplateSync = false;
                                 } else {
                                     self.alertStatus = 3;
                                     self.suggestTotalNum = total;
                                     self.suggestSuccessNum = active_num;
                                     if (active_num > 0) {
                                         self.modalSubTitle = '（共<span style="color:red">' + total + '</span>条优化建议，生效<span style="color:red">' + active_num + '</span>条）';
                                         self.currentTemplateStatus = 2;
                                     }
                                     self.showSyncAlert();
                                 }
                             } 
                         }
                         self.getDetailList(self.currentTab);
                     }, 1000);

                 });
         }
    }
}


</script>


<style scoped>
@import '../../css/base/variables.css';
@media (min-height:400px) and (max-height:650px) {
  .modal .modal-table-wrapper {
    max-height: calc(100vh - 200px);
    overflow: auto;
  }
  .modal-bd-wrapper >.min-height-table {
    min-height: 500px;
  }
}
@media (min-height:650px) {
  .modal-bd-wrapper >.min-height-table {
    min-height: 600px;
  }
}
.title-wrapper >*{ display: inline-block}
.indices-menu{ padding: 9px 0}
.opt-table thead tr{ background-color: #f6f7f9}
.modal{ width: 80%}
.modal-table thead tr th:last-child{ 
    max-width: 70px;
    text-align: center;
}
.modal-table thead tr th{ min-width: 120px}
.modal-bd-wrapper >.min-height-table{ 
    position: relative;
    padding-bottom: 5px;
    background-color: #fff;
}
.modal-bd-wrapper >div.chart-tip{ margin-top: 0; }
.modal-bd-wrapper{ min-width: 1000px; }
#odd-thead tr th{ min-width: 200px}
.del-td{ text-align: center}
.zone{ border-bottom-width: 1px}
.mr-20{ margin-right: 20px}
.mt-5{ margin-top: 5px}
.pointer{ cursor: pointer}
.i-ellipsis, .i-check-square, .i-minus-circle, .i-download{ 
    margin-right: 5px;
    vertical-align: middle;
}
.status-txt >small{ color: #9f9f9f}
.fa-ellipsis-h, .fa-ellipsis-h:hover{ color: #e5615a}
.fa-check-square-o, .fa-check-square-o:hover{ color: #47a3ff}
.fa-minus-circle, .fa-minus-circle:hover{ color: #a9b8c8}
.fa-edit, .fa-edit:hover, .fa-trash-o, .fa-trash-o:hover{ color: #a9b8c8}
.font-grey{ color: #575E66}
.btn-wrapper{ margin-left: 20px;}
.btn-absolute{
    position: absolute;
    bottom: 5px;
}
#priceList, #serviceList, #budgetList, #pauseList{ display: none}
td >input{
    width: auto;
    line-height: 2.5rem;
}
td >input[readonly], td > input[readonly]:focus{
    border: none;
    outline: none;
    -webkit-appearance: none;
    background: transparent;
}
input{max-width: 80px}
.sync-alert-wrapper{
    position: absolute;
    display: none;
    padding: 12px 12px 20px;
    box-shadow: 0px 0px 5px #ccc;
    bottom: 60px;
    left: 20px;
    border-radius: 5px;
    background-color: #fff;
    z-index : 999;

    & > .close{
        float: right;
        margin-bottom: 10px;
        color: #a0b1bf;
        font-size: 16px;
    }
    & > .diff-wrapper .title{
        clear: both;
        padding: 0 30px;
        font-size: 18px;
    }
    & > .diff-wrapper .alert-content{ 
        padding-left: 47px;
        color: #6c7680;
        margin-bottom: 20px;
    }
    & > .diff-wrapper .alert-top{ 
        margin-bottom: 3px;
    }
    & > .diff-wrapper .title .fa-ellipsis-h{
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 12px;
        background-color: #71abe8;
        color: #fff;
        font-weight: 100;
        vertical-align: top;
    }
    & > .diff-wrapper .title .fa-info-circle, & > .diff-wrapper .title .fa-info-circle{
        font-size: 24px;
        height: 24px;
        line-height: 24px;
        vertical-align: top;
    }
    & > .diff-wrapper .title .fa-info-circle{ color: #ffaa00;}
    & > .diff-wrapper .title .fa-check-circle{  color: #51c089;}
    & > .diff-wrapper .title span{
        color: #334866;
        line-height: 24px;
        display: inline-block;
        vertical-align: top;
    }
}
.modal .modal-table-wrapper {
  padding: 10px 20px;
}
.modal-table-wrapper .fa-trash{
    font-size: 16px;
    color: #a0b1bf;
    table{
        table-layout: fixed;
        width: 100%;
    }
}
.alert-show{display:inline-block}
.modal-shadow{
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.5);
    z-index: 102;
    top: 0;
    left: 0;
}
.opt-table th, .opt-table td{ 
    max-width: 600px;
    padding-right: 0;
}
.opt-table thead th:last-child{ width: 18%}

.floatr{ 
    float: right;
}
.radio-group{ margin-right: 20px;}
.charts{ 
    clear: both;
    border-top: none;  
}
.alert-wrapper-arrow{
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 11px solid;
    border-color: rgba(200,200,200,0.5) transparent transparent transparent;
    position: absolute;
    left: 50px;
    bottom: -22px;

    &:after{
        content: " ";
        display: block;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        position: absolute;
        border-top-color: #fff;
        border-bottom-width: 0;
        right: -10px;
        top: -12px;
        z-index: 9999;
    }
}
.download{
    color: #fff;
    background-color: #7D93B3;
    border: 1px solid #7D93B3;
}
.note-text{
    padding: 0;
    font-size: 12px;
    color: #a3b1bf;
    position: absolute;
    left: 165px;
    bottom: 10px;
}
.link-opt a{
  color: #56BF8B;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// operatelist.vue?1d57d699